import { customDropdownValueValidator } from "@jugl-web/domain-resources/custom-fields/utils";
import { CUSTOM_FIELD_DROPDOWN_VALUE_MAX_LENGTH } from "@jugl-web/domain-resources/tasks/consts";
import { FormGroup } from "@jugl-web/ui-components/cross-platform/forms/FormGroup";
import { FC, useEffect, useState } from "react";
import { TaskFieldSidebarListItemLayout } from "../../../TaskFieldSidebarListItemLayout";

interface DropdownValueListItemProps {
  text: string;
  color: string;
  isEditing: boolean;
  isReadonly?: boolean;
  className?: string;
  onChangeEditingState?: (isEditing: boolean) => void;
  onUpdate?: (text: string, color: string) => void;
  onDelete?: () => void;
}

export const DropdownValueListItem: FC<DropdownValueListItemProps> = ({
  text: initialText,
  color: initialColor,
  isEditing,
  isReadonly = false,
  className,
  onChangeEditingState,
  onUpdate,
  onDelete,
}) => {
  const [text, setText] = useState(initialText);
  const [color, setColor] = useState(initialColor);

  const isValid = customDropdownValueValidator(text);

  const handleStartEditing = () => {
    onChangeEditingState?.(true);
  };

  const handleFinishEditing = () => {
    onChangeEditingState?.(false);
    onUpdate?.(text, color);
  };

  useEffect(() => {
    setText(initialText);
    setColor(initialColor);
  }, [initialText, initialColor]);

  return (
    <FormGroup
      lengthIndicator={
        isEditing
          ? {
              current: text.length,
              max: CUSTOM_FIELD_DROPDOWN_VALUE_MAX_LENGTH,
            }
          : undefined
      }
      classNames={{ wrapperClassName: className }}
    >
      <TaskFieldSidebarListItemLayout.Root
        startSlot={
          <TaskFieldSidebarListItemLayout.ColorBox
            color={color}
            isDisabled={isReadonly}
            onColorChange={(c) => {
              if (isValid) {
                // If the value is valid, perform an update
                onUpdate?.(text, c);
              } else {
                // Otherwise, just change to color internally, so it's reflected in the UI
                setColor(c);
              }
            }}
          />
        }
        endSlot={
          !isReadonly &&
          onDelete && (
            <TaskFieldSidebarListItemLayout.RemoveButton onClick={onDelete} />
          )
        }
        isFocused={isEditing}
        onClick={!isReadonly && !isEditing ? handleStartEditing : undefined}
      >
        {isEditing ? (
          <TaskFieldSidebarListItemLayout.Input
            autoFocus
            value={text}
            maxLength={CUSTOM_FIELD_DROPDOWN_VALUE_MAX_LENGTH}
            onChange={setText}
            onAccept={handleFinishEditing}
          />
        ) : (
          <TaskFieldSidebarListItemLayout.Label>
            {text}
          </TaskFieldSidebarListItemLayout.Label>
        )}
      </TaskFieldSidebarListItemLayout.Root>
    </FormGroup>
  );
};
